import { ReactNode } from "react"

import ComingSoonBg from "@/assets/images/comingSoonBg.svg?react"
import Construction from "@/assets/images/construction.svg?react"
import { Button } from "@/components/ds/Button"
import { Typography } from "@/components/ds/Typography"

type Props = {
  icon?: ReactNode
  title?: ReactNode
  description?: ReactNode
  notifyMeButtonText?: string
  onNotifyMeButtonClick?: () => void
}

const ComingSoon = ({
  icon = <Construction />,
  title = "Coming Soon",
  description = "This feature is coming soon",
  notifyMeButtonText = "Notify Me",
  onNotifyMeButtonClick = () => {},
}: Props) => {
  return (
    <div className="relative flex h-full w-full items-center justify-center bg-neutral-secondBg px-6">
      <ComingSoonBg className="absolute left-1/2 top-1/2 z-0 aspect-square h-full w-full max-w-[996px] -translate-x-1/2 -translate-y-1/2" />
      <div className="relative z-10 flex flex-col items-center justify-center gap-4">
        {icon}
        <div className="flex flex-col items-center justify-center gap-6 text-center">
          <div>
            <Typography variant="body1" weight="medium" className="text-neutral-title">
              {title}
            </Typography>
            <Typography variant="body1" className="whitespace-pre-line text-neutral-text">
              {description}
            </Typography>
          </div>
          <Button variant="primary" size="medium" onClick={onNotifyMeButtonClick}>
            {notifyMeButtonText}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ComingSoon
